import { create } from "zustand";

export type ToastSeverity = "success" | "error" | "info" | "warning";

interface ToastState {
  open: boolean;
  message: string;
  severity: ToastSeverity;
  show: (message: string, severity?: ToastSeverity) => void;
  close: () => void;
}

export const useToast = create<ToastState>((set) => ({
  open: false,
  message: "",
  severity: "success",
  show: (message, severity = "success") => set({ open: true, message, severity }),
  close: () => set({ open: false }),
}));

// Imperative helpers usable outside React (e.g. the TanStack Query mutation cache).
export const notify = {
  success: (message: string) => useToast.getState().show(message, "success"),
  error: (message: string) => useToast.getState().show(message, "error"),
  info: (message: string) => useToast.getState().show(message, "info"),
  warning: (message: string) => useToast.getState().show(message, "warning"),
};
